module.exports = __webpack_public_path__ + "img/collection-weddingRingsExclusive.502aed2.webp";